import { useRef } from "react";
import { ImperativePanelHandle, Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useLocation, useNavigate } from "react-router";
import { GanttViewStrategyMapTimeline } from "../../../../pages/Timeline/StrategyMapTimeline";
import { newPath } from "../../../../utils/newPath";
import { smapNavigationLinkBuilder } from "../../../../utils/strategyMapUtils";
import { StrategyMapViewSidePanel } from "../../../StrategymapSidePanel/StrategyMapViewSidePanel";
import * as def from "../../StrategyMapView.def";
import { StrategyMapTimelineViewSkeleton } from "./StrategyMapTimelineViewSkeleton";

export const StrategyMapTimelineView = ({state}: {state: def.StrategyMapViewStateProps}  ) => {
  
    const navigate = useNavigate();
    const location = useLocation();
    const sidebarPanelRef = useRef<ImperativePanelHandle>(null);
    const ref = useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>;
    
    const {strageyMapData, sidebarCollapsed} = state.get;
   
    const setCollapsed = (collapsed: boolean) => {
        state.set((prev: def.StrategyMapViewStateType) => ({...prev, sidebarCollapsed: collapsed}));
        if (sidebarPanelRef.current) {
            setTimeout(() => {
                if (sidebarPanelRef.current) {
                    if (collapsed) {
                        sidebarPanelRef.current.resize(3);
                    } else {
                        sidebarPanelRef.current.resize(20);
                    }
                }
            }, 10);
        }
    }

    
    
    const onSMapClick = (entity: {type:string, id:string}) => {     
      const path = smapNavigationLinkBuilder(
        state.get.strageyMapData?.name ?? "",
        entity,
      );
      navigate(path);
    };

   

    return (
      <PanelGroup direction="horizontal">
        <Panel
          ref={sidebarPanelRef}
          collapsible={false}
          minSize={sidebarCollapsed ? 3 : 20}
          defaultSize={20}
          maxSize={40}
        >
        
            <StrategyMapViewSidePanel
              isSimulation={state.get.simulation}
              isLoading={state.get.loadingSingleStrategyMap}
              collapsed={sidebarCollapsed}
              onToggle={setCollapsed}
              strategyMapData={strageyMapData}
              events={{
                onTimelineViewClick: onSMapClick,
                onEntityClick: (entity) => {
                
                  
                  // Check if there's pre-existing history in the URL (query param or state) 
                  // and populate if needed. The user request was "if data is present in url ... please populate it here"
                  // referencing PreviousBreadCrumb logic.
                  // PreviousBreadCrumb looks at `previousRoute`. 
                  // If we want to *chain* lookups, we might check location.state?.history.
                  // But based on the request, replacing "current_url" with actual URL seems to be the main point,
                  // plus respecting the chain.
                  
                  navigate(
                    newPath({
                      active: entity.id,
                    }),
                  );
                },
                onViewChange: (view) => {
                  state.set((prev: def.StrategyMapViewStateType) => ({
                    ...prev,
                    gantViewMode: view,
                  }));
                },
              }}
            />

        </Panel>

        <PanelResizeHandle
          disabled={sidebarCollapsed}
          className={`w-0 relative ${sidebarCollapsed ? "cursor-default" : "cursor-col-resize"}`}
        >
          <div
            className={`absolute top-1/2 -translate-y-1/2 -left-2 bg-light-surfacePrimary dark:bg-secondary-dark flex flex-row border border-gray-200 dark:border-gray-700 rounded-full p-1 gap-0.5 transition-opacity ${sidebarCollapsed ? "opacity-0" : "opacity-100"}`}
          >
            <div className="w-0.5 h-4 bg-gray-400 dark:bg-gray-500 rounded-full"></div>
            <div className="w-0.5 h-4 bg-gray-400 dark:bg-gray-500 rounded-full"></div>
          </div>
        </PanelResizeHandle>

        <Panel>
          <div className="flex-1 overflow-hidden h-full relative">
            <div
              className="w-full h-full overflow-auto cursor-grab select-none overscroll-contain"
              id="timeline-container"
              ref={ref}
              onDragStart={(e) => e.preventDefault()}
              // style={{ overscrollBehavior: 'contain' }}
            >
              {state.get.loadingSingleStrategyMap || !strageyMapData ? (
                <StrategyMapTimelineViewSkeleton />
              ) : (
                <GanttViewStrategyMapTimeline
                  singleRoadmapRes={strageyMapData}
                  onProjectClick={onSMapClick}
                  dependecyView={state.get.gantViewMode === "dependencies"}
                  onTaskClick={() => {}}
                  simFlag={state.get.simulation}
                  orgId={state.get.orgDetails.orgId}
                  viewType={state.get.timelineViewType}
                  idForScroll={state.get.idForScroll}
                />
              )}
            </div>
          </div>
        </Panel>

        {/* <CreateWorkUnit isVisible={true} onClose={() => {}}></CreateWorkUnit> */}
      </PanelGroup>
    );
};